import { css } from 'styled-components';
import { ErrorModalProps } from './models';

export const ErrorModal = css<ErrorModalProps>(({ theme }) => {
  return css`
    background-color: white;
    border-radius: 16px;
    box-shadow: 0 8px 28px -6px ${theme.colors.lightGray};
    margin: auto;

    .dialog-title {
      font-weight: 600;
      font-size: 25px;
      line-height: 30px;
    }

    .popup-content {
      padding: 10px;

      .error-content-text {
        text-align: center;
      }
      h2 {
        font-size: 18px;
        line-height: 27px;
        font-weight: 500;
      }
      h4 {
        font-weight: 400;
        font-size: 14px;
        line-height: 21px;
      }
      h6 {
        font-size: 14px;
        line-height: 21px;
        font-weight: 600;
        margin: 15px;
      }
    }

    .blue-btn {
      margin: 0 10px;
      width: 100%;
    }
  `;
});
